import React, {Component} from 'react';

export default class KirokuCircleUp extends Component{

    handleClickMoveToTop = () => {
        window.scrollTo(0, 0);
    };

    render() {
        const {style} = this.props;
        return (
            <div className='circle-up-btn' style={{ textAlign : 'center', width: '100%', ...style}}>
                <i className='fa fa-chevron-circle-up fa-3x' onClick={this.handleClickMoveToTop.bind(this)}/>
            </div>
        )
    }
}
